import { API_GET_EXPRESS_LIST_SUCCESS } from "../actions/folder";
import { createReducer } from "@reduxjs/toolkit";
import { ErrorAction, errorHandler } from "utils/error";
import { toast } from "react-toastify";

const initialState = {
	list: [],
};

const express = createReducer(initialState, {
	/** GET EXPRESS LIST **/
	[API_GET_EXPRESS_LIST_SUCCESS]: (state, action) => {
		state.list = action.payload.data;
	},
});

export default express;
